<!--
 * @Author: zhaosujuan zhaosujuan@freedodata.com
 * @Date: 2022-10-25 09:05:08
 * @LastEditors: zhaosujuan zhaosujuan@freedodata.com
 * @LastEditTime: 2022-11-16 16:11:31
 * @FilePath: \lyws-official-websit\src\components\home.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <el-row class="home-container">
    <el-container>
        <el-header style="height:unset">
            <div class="header-block">
                <img class="logo-img" src="static/images/fdshuzi-white.png" alt="">
                <el-menu :default-active="defaultActivePath" class="el-menu-max" mode="horizontal" router @select="handleSelect">
                    <template v-for="(item,index) in menuList">
                        <el-menu-item v-if="!item.children" :index="item.path" :key="item.path">{{item.label}}</el-menu-item>
                        <el-submenu v-else :index="index.toString()" :key="index">
                            <template slot="title">{{item.label}}</template>
                            <template v-for="(subItem,subIndex) in item.children">
                                <el-menu-item v-if="subItem.children" :index="subItem.path" :key="subItem.path">{{subItem.label}}</el-menu-item>
                                <el-submenu v-else :index="`subIndex-${subIndex}`" :key="`subIndex-${subIndex}`">
                                    <template slot="title">{{subItem.label}}</template>
                                </el-submenu>
                            </template>
                        </el-submenu>
                    </template>
                </el-menu>
                <em class="el-icon-menu nav-app" @click="showDrawer = true"></em>
            </div>
        </el-header>
        <el-main>
            <router-view></router-view>
        </el-main>
        <el-footer style="height:100%">
            <div class="footer-block">
                <div class="copyright-block">
                    <p><span><a href="https://beian.miit.gov.cn/">浙ICP备2020030660号</a> Copyright © freedodata.com. All Rights Reserved &nbsp;&nbsp;</span><span>飞渡数字科技（杭州）有限公司版权所有</span></p>
                    <p><a href="">浙公网安备 33011002014960号</a></p>
                </div>
                <div class="code-block">
                    <div class="code-item-block">
                        <img src="static/images/LYWSPublicNumber@2x.png" alt="">
                        <span>官方公众号</span>
                    </div>
                    <div class="code-item-block">
                        <img src="static/images/LYWSPublicNumber@2x.png" alt="">
                        <span>官方微信</span>
                    </div>
                </div>
            </div>
        </el-footer>
    </el-container>
    <el-drawer
        class="nav-drawer"
        size="100%"
        append-to-body
        :visible.sync="showDrawer"
        :before-close="handleClose">
        <div slot="title">
            <img class="logo-img" src="static/images/home_tab_logo@2x.png" alt="飞渡数字">
        </div>
        <el-menu :default-active="defaultActivePath" class="el-menu-app" router @select="handleSelect">
            <template v-for="(item,index) in menuList">
                <el-menu-item v-if="!item.children" :index="item.path" :key="item.path">{{item.label}}</el-menu-item>
                <el-submenu v-else :index="index.toString()" :key="index">
                    <template slot="title">{{item.label}}</template>
                    <template v-for="(subItem,subIndex) in item.children">
                        <el-menu-item v-if="subItem.children" :index="subItem.path" :key="subItem.path">{{subItem.label}}</el-menu-item>
                        <el-submenu v-else :index="`subIndex-${subIndex}`" :key="`subIndex-${subIndex}`">
                            <template slot="title">{{subItem.label}}</template>
                        </el-submenu>
                    </template>
                </el-submenu>
            </template>
        </el-menu>
    </el-drawer>
  </el-row>
</template>

<script>
import { mutChangeDefaultActivePath } from '@/store/mutation-types.js';
import { mapState } from 'vuex';
export default {
    data() {
        return {
            showDrawer: false,
            menuList:[
                {label:'首页',path:'/index'},
                {label:'解决方案',path:'/solution'},
                {label:'成功案例',path:'/case'},
                {label:'关于我们',path:'/aboutUs'},
            ],
        }
    },
    computed: {
        ...mapState({
            defaultActivePath: state => state.defaultActivePath,
        }),
    },
    methods: {
        /**
         * @description: 切换路由
         * @param {*}
         * @return {*}
         */ 
        handleSelect(index,indexPath) {
            this.showDrawer = false;
            this.$store.commit(mutChangeDefaultActivePath,index);
        },
        handleClose() {
            this.showDrawer = false;
        },
    }
}
</script>

<style lang="scss">
@import '@/assets/css/home.scss';
</style>


// WEBPACK FOOTER //
// src/components/home.vue